
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Banner from '@cpg-its/ads.containers.banner';
import { useHistory } from 'react-router';
import { TcsmStates } from '../../root/tcsm-model';
import { ContentSpacer } from '../../global/components/layout/generic-content-spacer';
import { MyCpgPodsSettings, NewHireMemberPendingEnrollment } from '../mycpg-pods/mycpg-pod-models';
import { useBasePath } from '../../global/hooks/useBasePath';
import { AccountInfoRoutes } from '../account-info/constants/routes';
import { ArcRoutes } from '../arc/constants/routes';
import { setCurrentNewHireEnrollmentEligibility, setNewHireEnrollmentMemeberEmploymentData } from '../arc/features/new-hire-enrollment/slice/new-hire-enrollment-slices';

interface Props {
	settings: MyCpgPodsSettings;
}
export function MemberPendingEnrollmentNotification(props: Props) {
	const { settings } = props;

	const memberGHL = useSelector<TcsmStates, NewHireMemberPendingEnrollment[]>(state => state?.newHireEnrollmentState?.memberGhlEnrollments);
	const newHireEnrollmentPath = useBasePath(`${AccountInfoRoutes.MyCpgRoot}${ArcRoutes.MemberNewHireEnrollment}`);

	const history = useHistory();

	const dispatch = useDispatch();

	const handleNavigate = (enrollment: NewHireMemberPendingEnrollment) => {

		dispatch(setCurrentNewHireEnrollmentEligibility(!!enrollment?.id));
		dispatch(setNewHireEnrollmentMemeberEmploymentData(enrollment?.employment_id, enrollment?.employer));
		history.push(newHireEnrollmentPath);

	};

	const handleBannerTittle = (enrollment: NewHireMemberPendingEnrollment) => {

		if (!enrollment.employment_id) {
			return settings.participantPendingEnrollmentBannerTitle;
		}

		return settings?.pendingEnrollmentBannerTitle;
	};

	const handleURLButtonDescription = (enrollment: NewHireMemberPendingEnrollment) => {

		if (!enrollment.employment_id) {
			return settings?.participantPendingEnrollmentBannerUrlText;
		}

		return settings?.pendingEnrollmentBannerUrlText;
	};

	const handleBuildUrl = (enrollment: NewHireMemberPendingEnrollment) => {
		return (
			<>
				<button className='link-button' type='button' onClick={() => handleNavigate(enrollment)}>{handleURLButtonDescription(enrollment)}</button>
			</>
		);
	};

	const handleMemberRenderDescription = (enrollment: NewHireMemberPendingEnrollment) => {
		if (!settings?.pendingEnrollmentBannerDescription) return null;

		const institutionName = enrollment?.employer?.name || '';
		const linkButton = handleBuildUrl(enrollment);
		const completedDate = enrollment?.complete_by;

		const placeholders = {
			'Institution Name': institutionName,
			'Link Text': linkButton,
			'Date': completedDate,
		};

		const descriptionParts = settings.pendingEnrollmentBannerDescription.split(/\[(.*?)\]/g).map((part) => {
			return placeholders[part] || part;
		});

		return (
			<p>
				{descriptionParts}
			</p>
		);
	};

	const handleParticipantRenderDescription = (enrollment: NewHireMemberPendingEnrollment) => {
		if (!settings?.participantPendingEnrollmentBannerDescription) return null;

		const institutionName = enrollment?.employer?.name || '';
		const linkButton = handleBuildUrl(enrollment);
		const completedDate = enrollment?.complete_by;

		const placeholders = {
			'Institution Name': institutionName,
			'Link Text': linkButton,
			'Date': completedDate,
		};

		const descriptionParts = settings.participantPendingEnrollmentBannerDescription.split(/\[(.*?)\]/g).map((part) => {
			return placeholders[part] || part;
		});

		return (
			<p>
				{descriptionParts}
			</p>
		);
	};

	return (
		<>
			{memberGHL?.map((enrollment: NewHireMemberPendingEnrollment) => (
				<ContentSpacer>
					<div className="notification-banner">
						<Banner
							key={enrollment?.id}
							banner={{
								type: 'warning',
								label: <h5>{handleBannerTittle(enrollment)}</h5>,
								description: enrollment.employment_id ? handleMemberRenderDescription(enrollment) : handleParticipantRenderDescription(enrollment),
							}}
						/>
					</div>
				</ContentSpacer>
			))}
		</>
	);

}